import "../styles/footer.css";
import { FaInstagram, FaTiktok, FaWhatsapp , FaYoutube} from "react-icons/fa";

export default function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="footer-container">

          {/* BRAND */}
          <div className="footer-brand">
            <h3>Centro de Estudios Millenials</h3>
            <p>Aprender no tiene límites</p>
          </div>

          {/* CONTACTO */}
          <div className="footer-contact">
            <h4>Contacto</h4>

            <a
              href="https://wa.me/56954846238"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-item"
            >
              📞 <span>+56 9 5484 6238</span>
            </a>

            <a
              href="https://wa.me/56954846239"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-item"
            >
              📞 <span>+56 9 5484 6239</span>
            </a>
          </div>

          {/* REDES */}
          <div className="footer-socials">
            <a
              href="https://www.instagram.com/centro_millennials/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.tiktok.com/@centro.millennial"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
            >
              <FaTiktok />
            </a>

            <a
              href="https://www.youtube.com/@CEMCENTRODEESTUDIOSMILLENNIALS/videos"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className="youtube"
            >
              <FaYoutube />
            </a>
          </div>

        </div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} Centro de Estudios Millenials
        </div>
      </footer>

      {/* BOTÓN WHATSAPP */}
      <a
        href="https://wa.me/56954846238"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
      </a>
    </>
  );
}
